export default __webpack_public_path__ + "static/media/Definix-New-Klaytn-Logo.f73315cf.png";